
// import InlineSVG from 'svg-inline-react';
import Icons from './sprite.svg'

const Icon = ({ name, customClass}) => (
  <svg className={`icon icon-${name} ${customClass}`}>
    <use xlinkHref={`${Icons}#icon-${name}`} href={`${Icons}#icon-${name}`} />
  </svg>
);
const page = Icon;
export { page as Icon }